import { useRef, useState } from 'react';

export function useOpenLinkInNewTab(requestLink: () => Promise<{ url: string }>) {
    const [hasFailed, setHasFailed] = useState(false);
    // A second click can land before React re-renders the button as disabled.
    const isOpening = useRef(false);

    async function open() {
        if (isOpening.current) return;
        isOpening.current = true;
        // Opened synchronously: browsers only allow a new tab inside the click gesture.
        const tab = window.open('', '_blank');
        setHasFailed(false);
        if (!tab) {
            isOpening.current = false;
            setHasFailed(true);
            return;
        }
        // An expired session redirects this page and the request never settles; close the blank tab.
        const closeTab = () => tab.close();
        window.addEventListener('pagehide', closeTab);
        try {
            const { url } = await requestLink();
            tab.opener = null;
            tab.location.href = url;
        } catch {
            tab.close();
            setHasFailed(true);
        } finally {
            window.removeEventListener('pagehide', closeTab);
            isOpening.current = false;
        }
    }

    return { open, hasFailed };
}
